<template>
    <div>
      <br/>
      <v-flex xs5 offset-xs3>
          <v-card>
          <v-form v-model="valid">
      <v-text-field
        v-model="name"
        :rules="nameRules"
        :counter="10"
        label="Name"
        required
      ></v-text-field>
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        required
      ></v-text-field>
    </v-form>
      </v-card>
      </v-flex>
    </div>
</template>

<script>
export default {
    name: 'LoginPage'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/LoginPage.vue